export const formatNumber = (value, lang = "en") => {
  return new Intl.NumberFormat(lang === "ar" ? "ar-EG" : "en-US").format(value);
};
